import {
  CHAT_STATUS,
  GROUP_TYPE,
  IGroupChatData,
} from "@home-health-notify/domain";
import { ListItem, ListItemButton } from "@mui/material";
import { useTranslation } from "hhn-commons";
import { useSnackbar } from "notistack";
import React from "react";
import { Link } from "react-router";
import { ROUTES } from "../../../routes";
import { ChatListItemStatus } from "../../ChatListItemStatus";
import { DeletedChatListItem } from "../../DeletedChatListItem";
import { CHAT_DETAILS } from "./PatientChats";
import { PatientInfoContent } from "./PatientInfoContent";

type ChatListItemProps = {
  chatData: IGroupChatData;
  isSelected: boolean;
  showChatDetails?: CHAT_DETAILS;
  isHidden?: boolean;
};

function PatientGroupChatListItem({
  chatData,
  isSelected,
  showChatDetails = 0,
  isHidden = false,
}: ChatListItemProps): React.JSX.Element {
  const { t } = useTranslation("chat");
  const { enqueueSnackbar } = useSnackbar();
  const groupType = isHidden ? GROUP_TYPE.HIDDEN : chatData.groupType;
  const isDeleted = chatData.status === CHAT_STATUS.DELETED;
  const linkProps = isDeleted
    ? {
        onClick: (event: React.MouseEvent) => {
          event.preventDefault();
          enqueueSnackbar(t("groupDeletedToast"), { autoHideDuration: 3000 });
        },
      }
    : {
        component: Link,
        to: `../${ROUTES.CHATS}/${groupType.toLowerCase()}/${chatData.groupInfo.id}/message`,
      };
  const listItemProps = {
    disablePadding: true,
    divider: true,
    sx: { minHeight: "65px", overflowAnchor: "none" },
  };
  const content = (
    <ListItemButton
      disableGutters
      {...linkProps}
      selected={isSelected}
      sx={{
        padding: "10px 13px 10px 10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <PatientInfoContent
        showChatDetails={showChatDetails}
        chatData={chatData}
      />
      <ChatListItemStatus chatData={chatData} />
    </ListItemButton>
  );
  return isDeleted ? (
    <DeletedChatListItem {...listItemProps}>{content}</DeletedChatListItem>
  ) : (
    <ListItem {...listItemProps}>{content}</ListItem>
  );
}

export default PatientGroupChatListItem;
